import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { FilterList, FilterListItem } from 'react-admin';

import { ListFilterSidebar } from '@/components/filters/ListFilterSidebar';

/** Default / Open sidebar filter: pending + contacted (not done). */
export const LEAD_OPEN_STATUS_FILTER = {
    status: ['pending', 'contacted'],
};

export const LeadListFilter = () => (
    <ListFilterSidebar searchPlaceholder="Search name, email, phone">
        <FilterList label="Status" icon={<TrendingUpIcon />}>
            <FilterListItem label="Open" value={LEAD_OPEN_STATUS_FILTER} />
            <FilterListItem label="Show all" value={{ status: undefined }} />
            <FilterListItem label="Done" value={{ status: 'done' }} />
        </FilterList>
    </ListFilterSidebar>
);
